'use client';

import { SignIn } from '@clerk/nextjs';
import { Icons } from '@monorepo/ui';

interface SignInFormProps {
  email?: string;
  error?: string;
  redirectUrl?: string | null;
}

export default function SignInForm({ email, error, redirectUrl }: SignInFormProps) {
  return (
    <div className="mx-auto mt-6 max-w-[400px]">
      {error === 'invalid_token' && (
        <div className="mb-6 w-full">
          <div className="flex items-start gap-2 rounded-lg border border-gray-200 bg-white px-4 py-3 text-sm">
            <Icons.AlertCircle className="mt-0.5 h-4 w-4 flex-shrink-0 text-gray-500" />
            <div>
              <span className="font-medium text-gray-900">Invalid or Expired Link</span>
              <p className="mt-1 text-xs text-gray-600">
                The magic link you used has expired or has already been used. Please sign in below
                or request a new link.
              </p>
            </div>
          </div>
        </div>
      )}
      <SignIn
        withSignUp={true}
        initialValues={{
          emailAddress: email,
        }}
        // If a valid redirectUrl is provided, force redirect to it after sign in
        forceRedirectUrl={redirectUrl || undefined}
        // Also set fallback to ensure we don't get stuck on auth
        fallbackRedirectUrl={redirectUrl || undefined}
      />
    </div>
  );
}
